import { render } from "./GoogleOauthDemo.vue?vue&type=template&id=4599a9c2"
import script from "./GoogleOauthDemo.vue?vue&type=script&lang=js"
export * from "./GoogleOauthDemo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__